import { TabloPageBackgroundConfig } from '@ui/tablo-generator/types';

export const createDefaultTabloPageBackground =
  (): TabloPageBackgroundConfig => ({
    x: 0,
    y: 0,
    scale: 1,
  });

export const normalizeTabloPageBackground = (
  background?: Partial<TabloPageBackgroundConfig> | null,
): TabloPageBackgroundConfig => ({
  ...createDefaultTabloPageBackground(),
  ...(background ?? {}),
});

export const areTabloPageBackgroundsEqual = (
  left?: Partial<TabloPageBackgroundConfig> | null,
  right?: Partial<TabloPageBackgroundConfig> | null,
): boolean => {
  const normalizedLeft = normalizeTabloPageBackground(left);
  const normalizedRight = normalizeTabloPageBackground(right);

  return (
    normalizedLeft.x === normalizedRight.x &&
    normalizedLeft.y === normalizedRight.y &&
    normalizedLeft.scale === normalizedRight.scale
  );
};
